import {
  CREATE_PURCHASE_RETURN_REQUESTED,
  CREATE_PURCHASE_RETURN_SUCCESS,
  CREATE_PURCHASE_RETURN_ERRORED,
  GET_PURCHASE_RETURN_REQUESTED,
  GET_PURCHASE_RETURN_SUCCESS,
  GET_PURCHASE_RETURN_ERRORED,
  GET_PURCHASE_RETURN_DETAILS_REQUESTED,
  GET_PURCHASE_RETURN_DETAILS_SUCCESS,
  GET_PURCHASE_RETURN_DETAILS_ERRORED,
  UPDATE_PURCHASE_RETURN_REQUESTED,
  UPDATE_PURCHASE_RETURN_SUCCESS,
  UPDATE_PURCHASE_RETURN_ERRORED,
  DELETE_PURCHASE_RETURN_REQUESTED,
  DELETE_PURCHASE_RETURN_SUCCESS,
  DELETE_PURCHASE_RETURN_ERRORED,
} from "../constant/action-types";

const defaultState = {
  showGlobalLoader: false,
  purchaseReturn: [],
  purchaseReturnDetails: {},
  error: {},
};

export function purchaseReturn(state = defaultState, { type, payload }) {
  switch (type) {
    case CREATE_PURCHASE_RETURN_REQUESTED:
      return {
        ...state,
        showGlobalLoader: true,
      };

    case CREATE_PURCHASE_RETURN_SUCCESS:
      return {
        ...state,
        showGlobalLoader: false,
      };

    case CREATE_PURCHASE_RETURN_ERRORED:
      return {
        ...state,
        showGlobalLoader: false,
        error: payload,
      };

    case GET_PURCHASE_RETURN_REQUESTED:
      return {
        ...state,
        showGlobalLoader: true,
      };

    case GET_PURCHASE_RETURN_SUCCESS:
      return {
        ...state,
        purchaseReturn: payload,
        showGlobalLoader: false,
      };

    case GET_PURCHASE_RETURN_ERRORED:
      return {
        ...state,
        showGlobalLoader: false,
        error: payload,
      };

    case GET_PURCHASE_RETURN_DETAILS_REQUESTED:
      return {
        ...state,
        showGlobalLoader: true,
      };

    case GET_PURCHASE_RETURN_DETAILS_SUCCESS:
      return {
        ...state,
        purchaseReturnDetails: payload,
        showGlobalLoader: false,
      };

    case GET_PURCHASE_RETURN_DETAILS_ERRORED:
      return {
        ...state,
        showGlobalLoader: false,
        error: payload,
      };

    case UPDATE_PURCHASE_RETURN_REQUESTED:
      return {
        ...state,
        showGlobalLoader: true,
      };

    case UPDATE_PURCHASE_RETURN_SUCCESS:
      return {
        ...state,
        showGlobalLoader: false,
        purchaseReturnDetails: payload,
      };

    case UPDATE_PURCHASE_RETURN_ERRORED:
      return {
        ...state,
        showGlobalLoader: false,
        error: payload,
      };
    case DELETE_PURCHASE_RETURN_REQUESTED:
      return {
        ...state,
        showGlobalLoader: true,
      };

    case DELETE_PURCHASE_RETURN_SUCCESS:
      return {
        ...state,
        showGlobalLoader: false,
      };

    case DELETE_PURCHASE_RETURN_ERRORED:
      return {
        ...state,
        showGlobalLoader: false,
        error: payload,
      };

    default:
      return state;
  }
}
